export default {
  forms: {
    VERIFICATION: 'Customer Validation',
    REPORTING: 'Reporting Questions',
    DR_ENROLLMENT: 'DR Enrollment',
  },
  events: {
    OPENED: 'Opened',
    CLOSED: 'Closed',
    SUBMITTED: 'Submitted',
  },
};
